import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import taiChiWelcomeWebp from '@/assets/landing/welcome-for-google-tai-chi/tai-chi-welcome.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'TAI CHI <br/> FOR BEGINNERS',
			size: 'large',
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: 'Based on your <b>age</b>',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: taiChiWelcomeWebp,
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
